import React, { useState } from 'react';
import Section1 from './Section1';
import SectionVideos from './SectionVideos';
import Section5 from './Section5';
import Contacto from '../../components/Contacto/Contacto';
import Encuesta9DeJulio from '../../paginas/encuestas/Encuesta9DeJulio';
import ModalEncuesta from '../encuestas/ModalEncuesta';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  overflow: visible;
`;

const Section = styled.div`
  width: 100%;
  height: auto;
  min-height: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 8px;

  @media (max-width: 768px) {
    padding-top: 6px;
  }
`;

const Inicio = () => {
  const [mostrarModal, setMostrarModal] = useState(true);

  return (
   <>
  {/* 
  {mostrarModal && (
    <ModalEncuesta onClose={() => setMostrarModal(false)}>
      <Encuesta9DeJulio onClose={() => setMostrarModal(false)} />
    </ModalEncuesta>
  )}
  */}

  <Container>
    <Section>
      <Section1 />
    </Section>
    <Section>
      <SectionVideos />
    </Section>
    <Section>
      <Section5 />
    </Section>
    <Section>
      <Contacto />
    </Section>
  </Container>
</>

  );
};

export default Inicio;
